module.exports = __webpack_public_path__ + "static/media/producto1.779a7d8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/producto1.png
// module id = 251
// module chunks = 0